import { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { ensureCurrentUser } from '../../../util/data';
import { getVisitors } from '../VisitorsPage.helpers';

export const useVisitorsDataRequest = ({
    visitorsByType,
    representationListingId,
    perPage,
    page,
    setLoading,
    callback = () => null,
}) => {
    const [index, setIndex] = useState(0);
    const store = useStore();

    const dispatch = useDispatch();
    const currentUser = useSelector(state => ensureCurrentUser(state.user.currentUser));

    const visitorsNum = Array.isArray(visitorsByType) ? visitorsByType.length : 0;

    useEffect(() => {
        const getVisitorsData = async () => {
            setLoading(true);

            const visitors = await getVisitors({
                dispatch,
                setIndex,
                visitors: visitorsByType,
                representationListingId,
                currentUser,
                store,
                perPage,
                startingIndex: index,
            });

            callback(visitors);
        };

        if (visitorsNum) {
            getVisitorsData();
        }
    }, [visitorsNum, representationListingId, page]);
};
